import {
    useEffect
} from "react";
import {
    useGlobalState
} from "../../context";
import type RootStackParamList from "../../types/navigation";
import {
    createNativeStackNavigator
} from "@react-navigation/native-stack";
import AutoLogin from "../../pages/auth/autoLogin";
import {
    RESTService
} from "../../services/restAPI";
import {
    SERVICE_EVENT_TYPES
} from "../../services/restAPI/constants";
import AppStack from "../app";
import AuthStack from "../auth";
import CommonStack from "../common";
import GuestStack from "../guest";
import {
    navigationRef
} from "../index";

const Stack = createNativeStackNavigator<RootStackParamList>();

const RootStack = () => {
    const [
        globalState,
        setGlobalState
    ] = useGlobalState();

    useEffect(() => {
        const handleGoToLogout = () => {
            setGlobalState({
                isAppReady: true,
                isGuest: true,
                user: null
            });

            if(navigationRef.isReady()) {
                navigationRef.reset({
                    index: 0,
                    routes: [
                        {
                            name: "Auth"
                        }
                    ]
                });
            }
        };

        RESTService.addEventListener(
            SERVICE_EVENT_TYPES["GO_TO_LOGOUT"],
            handleGoToLogout
        );

        return () => {
            RESTService.removeEventListener(
                SERVICE_EVENT_TYPES["GO_TO_LOGOUT"]
            );
        };
    }, []);

    const renderMainStack = () => {
        if(!globalState.user || globalState.isGuest) {
            return <Stack.Screen
                name="Guest"
                component={GuestStack}
            />;
        }

        return <Stack.Screen
            name="App"
            component={AppStack}
        />;
    };

    return <Stack.Navigator
        initialRouteName="Main"
        screenOptions={{
            headerShown: false
        }}
    >
        {
            globalState.isAppReady ? null : <Stack.Screen
                name="Main"
                component={AutoLogin}
            />
        }
        {renderMainStack()}
        <Stack.Screen
            name="Common"
            component={CommonStack}
        />
        <Stack.Screen
            name="Auth"
            component={AuthStack}
        />
    </Stack.Navigator>;
};
export default RootStack;
